{
	"backLinkTitle": "Retour à la gestion des déclarations",
	"invoicedQuantity": "Quantité facturée",
	"remainingForDeclarationCreation": "Restant pour la création de déclaration",
	"nonTransferableAmount": "Montant non allouable",
	"btnCreateDeclaration": "+ Créer une déclaration",
	"errorMessage": "Échec du chargement des détails du matériau"
}
